import { render } from "./portalNav.vue?vue&type=template&id=18abec97&scoped=true"
import script from "./portalNav.vue?vue&type=script&lang=js"
export * from "./portalNav.vue?vue&type=script&lang=js"

import "./portalNav.vue?vue&type=style&index=0&id=18abec97&lang=scss&scoped=true"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18abec97"]])

export default __exports__